function activateToggle(toggle: HTMLInputElement): void {
  if (toggle.disabled) return

  toggle.click()
}

function activateSectionTitle(button: HTMLButtonElement): void {
  button.click()
}

/**
 * vanilla-cookieconsent toggles are checkboxes: Space works natively, Enter does not.
 * Section headers are buttons but keyboard activation can be inconsistent once styled.
 */
export function enhancePreferencesModalKeyboard(modal: HTMLElement): void {
  modal.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return

    const target = event.target
    if (!(target instanceof Element)) return

    const toggleInput =
      target instanceof HTMLInputElement && target.classList.contains('section__toggle')
        ? target
        : target.closest('.section__toggle-wrapper')?.querySelector('.section__toggle')

    if (toggleInput instanceof HTMLInputElement) {
      event.preventDefault()
      activateToggle(toggleInput)
      return
    }

    const sectionTitle = target.closest('.pm__section-title')
    if (sectionTitle instanceof HTMLButtonElement) {
      event.preventDefault()
      activateSectionTitle(sectionTitle)
    }
  })
}
